import React, { Component } from 'react';
import { Select, Radio } from 'antd';
import API_URL from '../../../../common/url';
import SearchMulSelect from '../../../common/SearchMulSelect';
import SymbolText from './SymbolText';
import Field from './Field';

const { Option } = Select;
const RadioGroup = Radio.Group;

class InvestigationArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            render: true,
            diseaseOption: []
        };
    }

    componentDidMount() {
        this.forceUpdate();
    }

    handleChange = (value, key) => {
        const { data, index, onChange } = this.props;
        switch(key) {
            case 'responsibleFieldId':
                const { symbol, id } = data;
                onChange({
                    id,
                    symbol,
                    responsibleFieldId: value,
                }, index);
                return;
            case 'investigationAreaId':
                data[key] = value;
                data.disease = [];
                this.setState({
                    render: false,
                    diseaseOption: []
                }, () => {
                    this.setState({ render: true });
                });
                break;
            case 'range':
                data[key] = value;
                data.diseaseDivide = undefined;
                data.disease = [];
                data.isCritical = undefined;
                this.setState({
                    render: false,
                    diseaseOption: []
                }, () => {
                    this.setState({ render: true });
                });
                break;
            case 'diseaseDivide':
                data[key] = value;
                data.disease = [];
                data.isCritical = undefined;
                this.setState({
                    render: false,
                    diseaseOption: []
                }, () => {
                    this.setState({ render: true });
                });
                break;
            default:
                data[key] = value;
                break;
        }
        onChange(data, index);
    }

    diseaseSelectChange = (value = []) => {
        const { data, index, onChange } = this.props;
        data.disease = value;
        onChange(data, index);
    }

    parseDiseaseData = res => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: item.diseaseName,
                value: String(item.diseaseId),
                fetching: false,
            }));
            this.setState({ diseaseOption: data });
        } else {
            this.setState({ diseaseOption: [] });
        }
    }

    render() {
        const { data, visible, fieldList, areaList, rangeList } = this.props;
        const { render, diseaseOption } = this.state;
        const { symbol, responsibleFieldId, investigationAreaId, range, diseaseDivide, disease, isCritical } = data;
        const areaOption = areaList.map(i => <Option key={i.investigationAreaId}>{i.investigationAreaName}</Option>);
        const rangeOption = rangeList.map(i => <Radio key={i.diseaseTypeId} value={i.diseaseTypeId}>{i.diseaseTypeName}</Radio>);
        return (
            <div>
                <SymbolText symbol={symbol} />
                <div className="border">
                    <div>
                        <Field value={responsibleFieldId} list={fieldList} onChange={this.handleChange} />
                        <span style={{ margin: '0 10px' }}>=</span>
                        <Select
                            value={investigationAreaId}
                            placeholder="请选择"
                            style={{ width: 240 }}
                            onChange={(value) => this.handleChange(value, 'investigationAreaId')}
                        >
                            {areaOption}
                        </Select>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <RadioGroup onChange={(e) => this.handleChange(e.target.value, 'range')} value={range}>
                            {rangeOption}
                        </RadioGroup>
                    </div>
                    {
                        range == 2 &&
                        <div style={{ marginTop: 10 }}>
                            <Select
                                value={diseaseDivide}
                                placeholder="请选择"
                                style={{ width: 160 }}
                                onChange={(value) => this.handleChange(value, 'diseaseDivide')}
                            >
                                <Option value="diseaseName">疾病名称</Option>
                                <Option value="isCritical">是否危急症</Option>
                            </Select>
                            <span style={{ margin: '0 10px' }}>=</span>
                            {
                                (diseaseDivide === 'diseaseName' && visible && render) ?
                                    <SearchMulSelect
                                        keyword='keyword'
                                        style={{width: 240}}
                                        url={API_URL.common.queryAllDisease}
                                        disabled={!diseaseDivide || !investigationAreaId}
                                        sourceData={diseaseOption}
                                        value={disease}
                                        searchParam={{limit: 20, investigationAreaId}}
                                        parseData={this.parseDiseaseData}
                                        handleSelect={this.diseaseSelectChange}
                                        placeholder='输入名称检索'
                                    />
                                :
                                    <Select
                                        value={isCritical}
                                        placeholder="请选择"
                                        style={{ width: 240 }}
                                        disabled={!diseaseDivide}
                                        onChange={(value) => this.handleChange(value, 'isCritical')}
                                    >
                                        <Option value="1">是</Option>
                                        <Option value="2">否</Option>
                                    </Select>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default InvestigationArea;


// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/InvestigationArea.js